import { render, staticRenderFns } from "./order-details-statis.vue?vue&type=template&id=280411e2&scoped=true"
import script from "./order-details-statis.vue?vue&type=script&lang=js"
export * from "./order-details-statis.vue?vue&type=script&lang=js"
import style0 from "./order-details-statis.vue?vue&type=style&index=0&id=280411e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280411e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('280411e2')) {
      api.createRecord('280411e2', component.options)
    } else {
      api.reload('280411e2', component.options)
    }
    module.hot.accept("./order-details-statis.vue?vue&type=template&id=280411e2&scoped=true", function () {
      api.rerender('280411e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statis/order-details-statis.vue"
export default component.exports